<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="page38" title="38">
<h1 class="recipe-title" id="AA4">GLUTEN-FREE OAT FLOUR PANCAKES</h1>
<p class="recipe-headnote">These gluten-free pancakes are fluffy, cozy, and craveable. This easily modifiable recipe can include a wide array of healthy fold-in ingredients like fresh blueberries, sliced bananas, chopped nuts, toasted coconut, sliced apples, and more! For everyone seeking gluten-free pancake bliss, this recipe is for you.</p>
<p class="yield">MAKES 4 LARGE PANCAKES OR 8 SMALL; SERVES 4</p>
<ul class="ing-list">
<li class="ingred">1 cup plus 1 tablespoon homemade oat flour (from rolled oats; see <a href="#/html/#homemade-flours">Sidebar</a>)</li>
<li class="ingred">1 tablespoon baking powder</li>
<li class="ingred">1 teaspoon ground flaxseeds</li>
<li class="ingred">⅛ to ¼ teaspoon sea salt</li>
<li class="ingred">Few pinches of ground cinnamon</li>
<li class="ingred">1 cup vanilla soy or almond milk</li>
<li class="ingred">1 ripe banana, mashed</li>
<li class="ingred">2 teaspoons fresh lemon juice</li>
<li class="ingred">2 teaspoons vegan sugar or agave syrup</li>
<li class="ingred">2 teaspoons safflower, sunflower, or melted virgin coconut oil</li>
<li class="ingred">¼ teaspoon pure vanilla extract</li>
<li class="ingred">Optional fruit, nuts, and more</li>
<li class="ingred">Oil, for the pan</li>
</ul>
<table class="method">
<tbody><tr><td class="stepnum"><p class="step-num">1</p></td>
<td><p class="step">Follow the <a href="#/html/page037">Basic Pancake Directions</a> to prepare the pancakes.</p></td></tr>
</tbody></table>
<div class="fact">
<h2 class="nutr-hed">NUTRITION FACTS</h2>
<p class="nutr-param">(per serving–151g)</p>
<p class="nutr">Calories: 225; Fat: 11g; Carbs: 27g; Protein: 6g; Fiber: 4g<br/>Vitamin C: 3%; Iron: 10%; Calcium: 25%; Vitamin A: 3%</p>
</div>
<div class="box70011" id="homemade-flours">
<h2 class="box-hed">HOMEMADE FLOURS: OAT, ALMOND, AND MORE</h2>
<p class="box-text">Homemade flour will change the way you bake and cook! Flours made from processed whole oats, nuts, and seeds can bring new life to your recipes. Plus, these flours are gluten-free! My favorite homemade flours are almond and rolled oat. Simply place the ingredient in a high-speed blender or food processor and blend from low to high power until powdery and soft. Just be careful with nuts. Blend too long and you will have nut butter. Blenders like Vitamix give you the option of purchasing a dry container made specifically for processing dry ingredients like flour. But the standard container will usually work, too. A food processor can also be used. Store leftover flour in an airtight container in the fridge and use it within a few weeks for oats and within a few days for nuts for the freshest flavors and textures. For longer storage, keep the flour in your freezer. Nut flour, which is high in fat, freezes very well. However, using it the same day is best.</p>
</div>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page038.vue?d7c0e080